/*
* AREA PAUSE BASELINE
*
* Strawman "shallow parabola" AREA/baseline approach -
* AREA of 5 = 5 second wait time
* AREA of 6.5 = 7 second wait time
* AREA of 9 = 3.75 second wait time
* For in between student AREA scores, linearly interpolate between these values
*/

export default function getAreaPauseBaseline(area) {
  if(area <= 5) {
    return 7000;
  } else if(area < 6.5) {
    return interpolate(5, 6.5, area, 7000, 8100);
  } else if(area < 9) {
    return interpolate(6.5, 9, area, 8100, 5450);
  }
  return 5450;
}

function interpolate(startAREA, endAREA, AREA, startRange, endRange) {
  // "percentage" interpolated, scaled from 0 to 1
  let percentageInterpolated = ((AREA - startAREA) / (endAREA - startAREA));
  let millisFromMin = (endRange - startRange) * percentageInterpolated;
  return (startRange + millisFromMin);
}

